import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "currentColor",
  "clip-path": "url(#i-291024754__a)"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 11.394c3.441 0 6.23-2.545 6.23-5.684S15.442.026 12 .026 5.77 2.57 5.77 5.71s2.789 5.684 6.23 5.684m2.077 1.264H9.923c-1.835.002-3.595.668-4.893 1.852S3.002 17.299 3 18.973v3.79c0 .335.146.656.406.893s.611.37.979.37h15.23c.368 0 .72-.133.98-.37a1.2 1.2 0 0 0 .405-.893v-3.79c-.002-1.674-.732-3.28-2.03-4.464s-3.058-1.85-4.893-1.852" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i-291024754__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 .026h24v24H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }